import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledSubtitle = styled.h2`
  margin: ${pxToRem(12)} ${pxToRem(24)};
`

interface StyledTopImageProps {
  theme: any;
}
export const StyledTopImage = styled.img<StyledTopImageProps>`
  ${({ theme }) => theme.custom_image_top}
`
